/* ==============================================================
   SUTRA helpers — hoisted so every IIFE can see them
   ============================================================== */
(function () {
  // Category detection that does NOT match "ring" inside "earrings".
  // Reads the URL first (most reliable — Shopify honours /products/<handle>),
  // then falls back to a whole-word title match with plural forms tested
  // first, so "earrings" cannot be swallowed by "ring".
window.sutraCategory = function () {
    var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
    var title = (document.querySelector('.product-information h1, main h1') || {}).textContent || '';
    var hay = ' ' + handle + ' ' + title.toLowerCase() + ' ';
    if (/(^|[-\s])earrings?([-\s]|$)/.test(hay))            return 'earrings';
    if (/(^|[-\s])(?:necklaces?|chokers?)([-\s]|$)/.test(hay)) return 'necklaces';
    if (/(^|[-\s])(?:bracelets?|bangles?|cuffs?)([-\s]|$)/.test(hay)) return 'bracelets';
    if (/(^|[-\s])pendants?([-\s]|$)/.test(hay))            return 'pendants';
    if (/(^|[-\s])(?:rings?|bands?)([-\s]|$)/.test(hay))    return 'rings';
    return '';
  }

  // Per-category copy — no more "your ring size" on earrings.
window.SUTRA_SIZE_COPY = {
    rings: {
      required: true,
      note: 'Every ring is raised to your finger — sizing is customisable at no extra cost. Tell us your ring size and we will make it to fit.',
      label: 'Your ring size',
      placeholder: 'e.g. US 7 — or a thread measurement in mm. Add any engraving, stone or finish preference here.',
      err:   'Please tell us your ring size before adding this piece — every ring is made to order.'
    },
    bracelets: {
      required: true,
      note: 'Every cuff and bangle is made to your wrist — sizing is customisable at no extra cost. Tell us your wrist circumference or inner-diameter preference.',
      label: 'Your wrist size',
      placeholder: 'e.g. wrist 15.5 cm, or inner diameter 55 mm. Add any preference here.',
      err:   'Please tell us your wrist size before adding this piece — every cuff and bangle is made to fit.'
    },
    necklaces: {
      required: false,
      note: 'Every piece is finished to your preferred chain length at no extra cost. Tell us the length you want, or leave the box empty for the standard fit.',
      label: 'Chain length or preferences',
      placeholder: 'e.g. 18 inch chain, or any stone, finish or engraving preference.',
      err: ''
    },
    earrings: {
      required: false,
      note: 'Every pair is finished by hand. If you would like a longer drop, a hook instead of a post, or any other adjustment, tell us here — it is included in the price.',
      label: 'Fit or finish preferences',
      placeholder: 'e.g. hooks instead of posts, longer drop, any engraving or finish preference.',
      err: ''
    },
    pendants: {
      required: false,
      note: 'Every pendant leaves the bench with a matching silver chain. If you would like a specific length or no chain at all, tell us here.',
      label: 'Chain length or preferences',
      placeholder: 'e.g. 16 inch chain, no chain, or any engraving or finish preference.',
      err: ''
    },
    '': {
      required: false,
      note: 'Every piece is made by hand and can be adjusted at no extra cost. Tell us anything we should know.',
      label: 'Preferences',
      placeholder: 'e.g. sizing, stone, finish or engraving preference.',
      err: ''
    }
  };
})();

/* SUTRA — buttery reveal-on-scroll micro-interactions.
   Tags elements with .sutra-in when they enter the viewport; CSS animates.
   Fully skipped when the user prefers reduced motion. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.classList.add('sutra-no-motion');
    return;
  }

  var SELECTORS = [
    '.sutra-cats__card',
    '.sutra-values__item',
    '.sutra-story__media',
    '.sutra-story__content',
    '.sutra-cats__heading',
    '.sutra-reviews__heading',
    '.sutra-review__card',
    '.sutra-shero__kicker',
    '.sutra-shero__line',
    '.sutra-shero__sub',
    '.sutra-shero__ctas',
    '.sutra-shero__footnote',
    '.sutra-eyebrow'
  ].join(',');

  function arm(scope) {
    var els = scope.querySelectorAll(SELECTORS);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el.hasAttribute('data-sutra-reveal')) {
        el.setAttribute('data-sutra-reveal', '');
        var idx = 0, p = el.previousElementSibling;
        while (p) {
          if (p.matches && p.matches(SELECTORS)) idx++;
          p = p.previousElementSibling;
        }
        el.style.setProperty('--sutra-i', idx > 8 ? 8 : idx);
        io.observe(el);
      }
    }
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        entries[i].target.classList.add('sutra-in');
        io.unobserve(entries[i].target);
      }
    }
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function revealPending() {
    var pending = document.querySelectorAll('[data-sutra-reveal]:not(.sutra-in)');
    for (var i = 0; i < pending.length; i++) {
      var r = pending[i].getBoundingClientRect();
      if (r.top < window.innerHeight + 80) pending[i].classList.add('sutra-in');
    }
  }

  function init() {
    document.documentElement.classList.add('sutra-motion');
    arm(document);
    setTimeout(revealPending, 3000);
    setTimeout(function () {
      var pending = document.querySelectorAll('[data-sutra-reveal]:not(.sutra-in)');
      for (var i = 0; i < pending.length; i++) pending[i].classList.add('sutra-in');
    }, 6000);
  }

  var scrollRaf = null;
  window.addEventListener('scroll', function () {
    if (scrollRaf) return;
    scrollRaf = requestAnimationFrame(function () {
      scrollRaf = null;
      revealPending();
    });
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);

  /* ---- Stat figures are STATIC (audit 1.5) ----
     The count-up animation printed false claims on the way to the real
     number — a visitor scrolling slowly read "3.4 rated atelier" and
     "67% handcrafted". The Liquid already renders the final figure, so
     the animation is gone entirely and the number is simply correct. */

  /* ---- Scroll progress hairline (gold, above header) ---- */
  var bar = document.createElement('div');
  bar.className = 'sutra-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);

  /* ---- Back to top ---- */
  var topBtn = document.createElement('button');
  topBtn.className = 'sutra-top';
  topBtn.setAttribute('aria-label', 'Back to top');
  topBtn.innerHTML = '&uarr;';
  topBtn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  document.body.appendChild(topBtn);

  var uiRaf = null;
  function uiTick() {
    uiRaf = null;
    var doc = document.documentElement;
    var max = doc.scrollHeight - window.innerHeight;
    var y = window.scrollY || doc.scrollTop;
    bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(y / max, 1) : 0) + ')';
    topBtn.classList.toggle('sutra-top--show', y > 850);
  }
  window.addEventListener('scroll', function () {
    if (!uiRaf) uiRaf = requestAnimationFrame(uiTick);
  }, { passive: true });
  uiTick();

  /* ---- Cursor gold glow on atmospheric (dark) sections ---- */
  if (window.matchMedia('(pointer: fine)').matches) {
    var GLOW_SEL = '.sutra-story, .sutra-values, .sutra-stats';
    var glowRaf = null;
    document.addEventListener('pointermove', function (e) {
      if (glowRaf) return;
      glowRaf = requestAnimationFrame(function () {
        glowRaf = null;
        var sec = e.target.closest && e.target.closest(GLOW_SEL);
        var lit = document.querySelectorAll('.sutra-glow-on');
        for (var i = 0; i < lit.length; i++) {
          if (lit[i] !== sec) lit[i].classList.remove('sutra-glow-on');
        }
        if (!sec) return;
        var r = sec.getBoundingClientRect();
        sec.style.setProperty('--sutra-mx', ((e.clientX - r.left) / r.width * 100).toFixed(2) + '%');
        sec.style.setProperty('--sutra-my', ((e.clientY - r.top) / r.height * 100).toFixed(2) + '%');
        sec.classList.add('sutra-glow-on');
      });
    }, { passive: true });
  }

  /* ---- 3D cursor tilt for holo cards (fine pointers only) ---- */
  if (window.matchMedia('(pointer: fine)').matches) {
    var TILT_SEL = '.product-card, .sutra-cats__card';
    var MAX_X = 7, MAX_Y = 9; // degrees
    var rafId = null;

    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest(TILT_SEL);
      if (!card) return;
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.classList.add('sutra-tilting');
        card.style.setProperty('--rx', (-py * MAX_X).toFixed(2) + 'deg');
        card.style.setProperty('--ry', (px * MAX_Y).toFixed(2) + 'deg');
      });
    }, { passive: true });

    document.addEventListener('pointerout', function (e) {
      var card = e.target.closest && e.target.closest(TILT_SEL);
      if (!card) return;
      if (e.relatedTarget && card.contains(e.relatedTarget)) return;
      card.classList.remove('sutra-tilting');
      card.style.setProperty('--rx', '0deg');
      card.style.setProperty('--ry', '0deg');
    }, { passive: true });
  }
})();

/* ==============================================================
   SUTRA v9 — image resolution, search-panel ghosts, card hover
   ============================================================== */
(function () {
  /* ---- FULL-RESOLUTION PHOTOGRAPHY -------------------------------
     Horizon's `sizes` attribute describes the CSS box (e.g. 25vw =
     320px), so the browser downloads a 240w or 352w file and paints
     it into a 770px frame — that is the softness. The srcset already
     carries 1600w / 1920w / 2560w / 3840w sources, so widening
     `sizes` makes the browser pick a genuinely high-resolution file.
     No URL rewriting, no extra requests: the same srcset, chosen
     properly. ------------------------------------------------------ */
  // Cards and tiles keep a responsive srcset — only `sizes` is corrected.
  var HI = [
    ['.card-gallery img, product-card img, .product-card img', '(min-width: 990px) 25vw, (min-width: 750px) 33vw, 50vw'],
    ['.sutra-cats__card img, .sutra-story__media img', '(min-width: 750px) 25vw, 50vw']
  ];

  // The product gallery is the one place the customer inspects the metal, so
  // it gets a single explicit high-resolution source instead.
  // Scoped to the product-page gallery ONLY. `.product-media__image` is also
  // the class Horizon puts on product-CARD images, so the un-scoped selector
  // was stripping srcset from every thumbnail and forcing it to width=2048 —
  // which is how the homepage went from 3.0 MB to 8.75 MB.
  var GALLERY = 'media-gallery img, [class*="media-gallery"] img';
  var GALLERY_W = 2048;

  // Rebuild a Shopify CDN url from its file path rather than editing the query
  // string. Horizon's urls carry crop=center together with height=, and a crop
  // request larger than the stored original comes back SMALLER, not bigger —
  // which is why patching only `width` made each reload softer than the last.
  // Keep the cache-busting v= and nothing else.
  function atWidth(url, w) {
    // The storefront serves images from sutraofficial.com/cdn/shop/… , not
    // cdn.shopify.com — that is only what the Admin API hands back. Match the
    // /cdn/ path so both forms are covered.
    if (!url || url.indexOf('/cdn/') === -1) return null;
    var file = url.match(/^(https?:\/\/[^?#]+?\.(?:jpe?g|png|webp|gif|avif))/i);
    if (!file) return null;
    var v = (url.match(/[?&](v=\d+)/) || [])[1];
    return file[1] + '?' + (v ? v + '&' : '') + 'width=' + w;
  }

  // Idempotent on purpose: Horizon's slideshow re-renders its slides and puts
  // the original srcset back, so a one-shot "already done" flag silently loses.
  // This re-asserts itself instead, and does nothing when already correct.
  var DONE = 'width=' + GALLERY_W;

  function upgradeGallery(scope) {
    var imgs = scope.querySelectorAll(GALLERY);
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var src = img.getAttribute('src') || '';
      if (!img.getAttribute('srcset') && src.indexOf(DONE) !== -1) continue;

      // srcset always beats src, so pointing src at a bigger file does nothing
      // while a srcset is present — and Horizon's `sizes="auto, …"` makes
      // Chrome size lazy images from whatever layout box existed at load time,
      // which is how a 599px frame ended up holding a 375px file. Drop both and
      // name one source outright. Shopify never upscales past the original
      // upload, so this can only stop us under-serving, never bloat a request.
      var big = atWidth(img.currentSrc || src, GALLERY_W);
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      if (big && img.getAttribute('src') !== big) img.setAttribute('src', big);
    }
  }

  function upgrade(scope) {
    upgradeGallery(scope);
    for (var h = 0; h < HI.length; h++) {
      var imgs = scope.querySelectorAll(HI[h][0]);
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        if (img.dataset.sutraHi) continue;
        if (!img.getAttribute('srcset')) continue;
        img.dataset.sutraHi = '1';
        img.setAttribute('sizes', HI[h][1]);
      }
    }
  }

  /* ---- SEARCH PANEL GHOSTS (audit 1.2) ---------------------------
     Horizon pads "Recently viewed" to four tiles with skeleton demo
     cards priced $19.99. A real card always links to /products/. --- */
  function stripGhosts() {
    var panels = document.querySelectorAll(
      '[class*="recently-viewed"], #search-modal, .search-modal, dialog[open]');
    for (var p = 0; p < panels.length; p++) {
      var cards = panels[p].querySelectorAll('product-card, .product-card, .card-gallery');
      var live = 0;
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var link = card.querySelector('a[href*="/products/"]') ||
                   (card.closest && card.closest('a[href*="/products/"]'));
        if (link) { live++; continue; }
        var host = card.closest('li, .product-grid__item, .grid__item') || card;
        host.classList.add('sutra-ghost-hidden');
      }
      if (!live) {
        var block = panels[p].closest('[class*="recently-viewed"]');
        if (block) block.classList.add('sutra-ghost-hidden');
      }
    }
  }

  function run() { upgrade(document); stripGhosts(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }

  document.addEventListener('shopify:section:load', run);
  window.addEventListener('pageshow', run);
  document.addEventListener('click', function () { setTimeout(run, 350); }, true);

  // New nodes (search results, quick add, carousel paging) AND attribute
  // rewrites — the slideshow puts its own srcset back on existing <img>
  // elements, which is a childList-blind mutation. upgradeGallery() is a
  // no-op once a node is already correct, so this settles instead of looping.
  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if ((m.addedNodes && m.addedNodes.length) || m.type === 'attributes') {
          clearTimeout(mo._t);
          mo._t = setTimeout(run, 120);
          return;
        }
      }
    });
    mo.observe(document.documentElement, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['srcset', 'sizes']
    });
  }
})();

/* ==============================================================
   SUTRA v9 — trust row + ring-size link beneath Add to Cart
   ============================================================== */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  var ICON = {
    silver: '<path d="M12 3 4 7v5c0 4.4 3.2 8.2 8 9 4.8-.8 8-4.6 8-9V7z"/>',
    ship: '<path d="M2 16V8h11v8zM13 11h4l3 3v2h-7z"/><circle cx="6.5" cy="18" r="1.6"/><circle cx="16.5" cy="18" r="1.6"/>',
    ret: '<path d="M4 11a8 8 0 1 1 2.3 5.6"/><path d="M4 6v5h5"/>',
    lock: '<rect x="4.5" y="10" width="15" height="10"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>'
  };

  // 14 days, not 7 — the UK/EU cooling-off minimum. The resize line is
  // ring-only; it was previously shown on necklaces and earrings too.
  // v17: "worldwide" came out — checkout only offers India until an
  // international market is switched on, and a promise the checkout then
  // breaks costs more trust than it earns. Dispatch times are the shipping
  // policy's own: made-to-size pieces 10–15 business days, the rest 2–5.
  function items(isRing) {
    var cat = window.sutraCategory();
    var made = /^(rings|bracelets)$/.test(cat);
    // earrings are returnable only with the pouch seal intact (hygiene rule)
    var ret = isRing ? '14-day returns &middot; first resize free'
            : cat === 'earrings' ? '14-day returns while the pouch seal is unbroken'
            : '14-day returns &middot; refund to original payment';
    return [
      [ICON.silver, 'Solid 925 sterling silver, honestly described'],
      [ICON.ship, made ? 'Made to your size &middot; ships in 10&ndash;15 business days'
                       : 'Tracked &amp; insured &middot; ships in 2&ndash;5 business days'],
      [ICON.ret, ret],
      [ICON.lock, 'Secure checkout &middot; UPI &amp; all major cards']
    ];
  }

  function svg(path) {
    return '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" ' +
           'stroke="currentColor" stroke-width="1.5" aria-hidden="true">' + path + '</svg>';
  }

  function build() {
    if (document.querySelector('.sutra-trust')) return;
    var btn = document.querySelector(
      'add-to-cart-component, .product-form__buttons, [name="add"], .shopify-payment-button');
    if (!btn) return;
    var anchor = btn.closest('.product-form, product-form-component, .product-details') || btn.parentElement;
    if (!anchor) return;

    var box = document.createElement('div');
    box.className = 'sutra-trust';
    var LIST = items(window.sutraCategory() === 'rings');
    var html = '';
    for (var i = 0; i < LIST.length; i++) {
      html += '<div class="sutra-trust__item">' + svg(LIST[i][0]) +
              '<span>' + LIST[i][1] + '</span></div>';
    }
    box.innerHTML = html;
    anchor.appendChild(box);

    // rings only — the size guide is not much use on a pendant
    var title = (document.querySelector('.product-information h1, h1') || {}).textContent || '';
    if (window.sutraCategory() === 'rings') {
      var a = document.createElement('a');
      a.className = 'sutra-sizelink';
      a.href = '/pages/size-guide';
      a.textContent = 'Not sure of your size? Read the ring size guide';
      anchor.appendChild(a);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else { build(); }
  window.addEventListener('pageshow', build);
  document.addEventListener('shopify:section:load', build);
  setTimeout(build, 600);
  setTimeout(build, 1800);
})();

/* ==============================================================
   SUTRA v10 — made-to-size capture, one-of-a-kind, marquee pause
   ============================================================== */
(function () {
  /* ---- MADE TO SIZE (audit 1.1) ---------------------------------
     15 of 22 pieces are rings and there was no way for a buyer to
     tell us a size — the only field on the whole site was the
     collapsed "Special instructions" box on the cart page. This
     puts a real line-item property on the product form, so the
     size travels with the order into the admin. ------------------ */


  /* ---- GIFT NOTE (round 5) --------------------------------------
     Giva and Mia both let a buyer attach a message to a gift; SUTRA
     had no way to do it. Kept collapsed behind a single line so it
     costs nothing visually until someone actually wants it — the
     brief for this round was "less loaded", not "more fields". ---- */

  function giftNote() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('.sutra-gift')) return;

    var form = document.querySelector('form[action*="/cart/add"], product-form-component form');
    if (!form) return;

    var box = document.createElement('div');
    box.className = 'sutra-gift';
    box.innerHTML =
      '<button type="button" class="sutra-gift__toggle" aria-expanded="false" ' +
        'aria-controls="sutra-gift-panel">' +
        '<span class="sutra-gift__plus" aria-hidden="true">+</span> Add a gift note' +
      '</button>' +
      '<div class="sutra-gift__panel" id="sutra-gift-panel" hidden>' +
        '<label for="sutra-gift-msg">Your message ' +
          '<span class="sutra-gift__opt">(optional)</span></label>' +
        '<textarea id="sutra-gift-msg" name="properties[Gift note]" maxlength="200" ' +
          'placeholder="We will hand-write this on the card that goes in the box."></textarea>' +
        '<p class="sutra-gift__hint"><span class="sutra-gift__count">0</span>/200 · ' +
          'Leave the price off? <label class="sutra-gift__hide">' +
          '<input type="checkbox" name="properties[Hide price on invoice]" value="Yes"> ' +
          'Hide the price</label></p>' +
      '</div>';

    var btn = form.querySelector('add-to-cart-component, [name="add"], .product-form__buttons');
    if (btn && btn.parentElement) btn.parentElement.insertBefore(box, btn);
    else form.appendChild(box);

    var toggle = box.querySelector('.sutra-gift__toggle');
    var panel = box.querySelector('.sutra-gift__panel');
    var ta = box.querySelector('textarea');
    var count = box.querySelector('.sutra-gift__count');

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
      box.classList.toggle('sutra-gift--open', !open);
      if (!open) ta.focus();
    });
    ta.addEventListener('input', function () {
      count.textContent = String(ta.value.length);
    });
  }

  function sizePanel() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('.sutra-custom')) return;

    var form = document.querySelector('form[action*="/cart/add"], product-form-component form');
    if (!form) return;

    var cat = window.sutraCategory();
    var C = window.SUTRA_SIZE_COPY[cat] || window.SUTRA_SIZE_COPY[''];

    var box = document.createElement('div');
    box.className = 'sutra-custom sutra-custom--' + (cat || 'default');
    box.innerHTML =
      '<p class="sutra-custom__h">Made to your size</p>' +
      '<p class="sutra-custom__note">' + C.note + '</p>' +
      '<label for="sutra-props">' + C.label +
        (C.required
          ? ' <span aria-hidden="true">*</span>'
          : ' <span class="sutra-custom__opt">(optional)</span>') +
      '</label>' +
      '<textarea id="sutra-props" name="properties[Size &amp; preferences]" ' +
        (C.required ? 'required aria-required="true" ' : '') +
        'placeholder="' + C.placeholder + '"></textarea>' +
      '<p class="sutra-custom__hint">Not sure? ' +
        (cat === 'rings'
          ? '<a href="/pages/size-guide">Read the ring size guide</a> or '
          : '') +
        '<a href="https://wa.me/919929615965" target="_blank" rel="noopener">message us on WhatsApp</a> ' +
        '— we will help before you order.</p>';

    var btn = form.querySelector('add-to-cart-component, [name="add"], .product-form__buttons');
    if (btn && btn.parentElement) btn.parentElement.insertBefore(box, btn);
    else form.appendChild(box);

    if (!C.required) return;

    // Horizon submits with fetch(), so native `required` alone never fires.
    var ta = box.querySelector('textarea');
    form.addEventListener('click', function (ev) {
      var add = ev.target.closest('[name="add"], add-to-cart-component button, .product-form__buttons button');
      if (!add) return;
      if (ta.value.trim().length >= 1) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      ta.focus();
      box.classList.add('sutra-custom--error');
      if (!box.querySelector('.sutra-custom__err')) {
        var m = document.createElement('p');
        m.className = 'sutra-custom__err';
        m.setAttribute('role', 'alert');
        m.textContent = C.err;
        box.appendChild(m);
      }
    }, true);
    ta.addEventListener('input', function () {
      if (ta.value.trim()) box.classList.remove('sutra-custom--error');
    });
  }

  /* ---- ONE OF A KIND --------------------------------------------
     Every piece has stock 1. The stepper let a shopper pick 3 and
     then showed three contradictory numbers, so the stepper is
     hidden in CSS and the scarcity is stated instead. ------------ */
  function oneOfAKind() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('.sutra-oneof')) return;
    var anchor = document.querySelector('.product-information product-price, .product-information .price');
    if (!anchor || !anchor.parentElement) return;
    var b = document.createElement('span');
    b.className = 'sutra-oneof';
    b.textContent = 'One of a kind — only one made';
    anchor.parentElement.insertBefore(b, anchor);
    var q = document.querySelector('input[name="quantity"]');
    if (q) { q.value = 1; q.max = 1; }
  }

  /* ---- MARQUEE PAUSE (WCAG 2.2.2) ------------------------------ */
  function marqueePause() {
    var m = document.querySelector('.sutra-marquee');
    if (!m || m.querySelector('.sutra-marquee__pause')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sutra-marquee__pause';
    b.setAttribute('aria-label', 'Pause the scrolling banner');
    b.setAttribute('aria-pressed', 'false');
    b.textContent = 'Pause';
    b.addEventListener('click', function () {
      var paused = m.classList.toggle('is-paused');
      b.setAttribute('aria-pressed', paused ? 'true' : 'false');
      b.textContent = paused ? 'Play' : 'Pause';
      b.setAttribute('aria-label', paused ? 'Resume the scrolling banner'
                                          : 'Pause the scrolling banner');
    });
    m.appendChild(b);
  }

  /* ---- ACCESSIBLE NAMES (audit 5.3) ---------------------------- */
  function labelThings() {
    var logo = document.querySelector('a.header-logo, .header-logo a, a[class*="header-logo"]');
    if (logo && !logo.getAttribute('aria-label')) {
      logo.setAttribute('aria-label', 'SUTRA — home');
    }
    var email = document.querySelector('.sutra-news__input, input[type="email"]');
    if (email && !email.getAttribute('aria-label')) {
      email.setAttribute('aria-label', 'Email address');
    }
  }

  /* ---- H1 (audit 4.1) -------------------------------------------
     The only H1 was a hidden "SUTRA"; the real keyword line was an
     H2. Promote the descriptive line on the home page. ----------- */
  function fixHeadings() {
    if (location.pathname !== '/' && location.pathname !== '') return;
    var hidden = document.querySelector('h1.visually-hidden, h1[class*="visually-hidden"]');
    var real = document.querySelector('.sutra-banner__h1');
    if (!real) return;
    if (hidden) {
      var span = document.createElement('span');
      span.className = hidden.className;
      span.textContent = hidden.textContent;
      hidden.parentElement.replaceChild(span, hidden);
    }
    if (real.tagName !== 'H1') {
      var h1 = document.createElement('h1');
      h1.className = real.className;
      h1.textContent = real.textContent;
      real.parentElement.replaceChild(h1, real);
    }
  }

  /* ---- OPEN GRAPH (audit 4.4 / 4.5) ---------------------------- */
  function fixOg() {
    var img = document.querySelector('meta[property="og:image"]');
    if (img && /^http:\/\//i.test(img.content)) {
      img.content = img.content.replace(/^http:\/\//i, 'https://');
    }
    var t = document.querySelector('meta[property="og:title"]');
    if (t && (t.content || '').trim().length < 12) t.content = document.title;
    var d = document.querySelector('meta[property="og:description"]');
    var md = document.querySelector('meta[name="description"]');
    if (d && md && (d.content || '').length < 20) d.content = md.content;
  }

  // The digits sit in a span the a11y tree was skipping, so a screen-reader
  // user heard four labels and no numbers.
  function statsA11y() {
    var items = document.querySelectorAll('.sutra-stats__item');
    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute('aria-label')) continue;
      var txt = items[i].textContent.replace(/\s+/g, ' ').trim();
      if (txt) items[i].setAttribute('aria-label', txt);
    }
  }

  // Each card carried two links to the same URL with the same name, so
  // keyboard and screen-reader users met every product twice.
  function dedupeCardLinks() {
    var cards = document.querySelectorAll('product-card, .product-card');
    for (var i = 0; i < cards.length; i++) {
      var links = cards[i].querySelectorAll('a[href*="/products/"]');
      for (var j = 1; j < links.length; j++) {
        links[j].setAttribute('tabindex', '-1');
        links[j].setAttribute('aria-hidden', 'true');
      }
    }
  }

  function run() {
    sizePanel(); giftNote(); oneOfAKind(); marqueePause(); statsA11y(); dedupeCardLinks();
    labelThings(); fixHeadings(); fixOg();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  window.addEventListener('pageshow', run);
  document.addEventListener('shopify:section:load', run);
  setTimeout(run, 500);
  setTimeout(run, 1600);
})();

/* ==============================================================
   SUTRA v11 — floats yield to the footer, dead policy control
   ============================================================== */
(function () {
  /* Both floating buttons sat over real content near the bottom of the
     page — product titles, the FOLLOW column, the copyright. Rather than
     nudging offsets forever, they simply stand down once the footer is
     on screen. */
  var foot = document.querySelector('footer, .sutra-foot-section');
  if (foot && window.IntersectionObserver) {
    new IntersectionObserver(function (e) {
      document.body.classList.toggle('sutra-at-footer', e[0].isIntersecting);
    }, { rootMargin: '0px 0px -10% 0px' }).observe(foot);
  }

  /* "Terms and Policies" had become a <button> with no href and no
     handler — it looked right and did nothing when clicked. */
  function fixPolicyControl() {
    var nodes = document.querySelectorAll('button, a');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var t = (n.textContent || '').trim().toLowerCase();
      if (t !== 'terms and policies' && t !== 'terms & policies') continue;
      if (n.tagName === 'A' && n.getAttribute('href')) continue;
      var a = document.createElement('a');
      a.href = '/pages/terms-of-service-sutra';
      a.className = n.className;
      // the label promised all four policies and delivered one
      a.textContent = 'Terms of Service';
      n.parentElement.replaceChild(a, n);
    }
  }

  /* A 1-of-1 piece should not offer "+" in the cart either — the PDP was
     capped but the cart line was not, so the stepper flashed 3 then snapped
     back with an availability warning. */
  function capCartQty() {
    var inputs = document.querySelectorAll('cart-items input[name="updates[]"], .cart-item input[type="number"]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      if (inp.dataset.sutraCap) continue;
      inp.dataset.sutraCap = '1';
      inp.max = inp.max && inp.max !== '0' ? inp.max : '1';
      var plus = inp.parentElement && inp.parentElement.querySelector('[name="plus"], .quantity__button--plus, button[aria-label*="ncrease"]');
      if (plus && Number(inp.value) >= Number(inp.max || 1)) {
        plus.setAttribute('disabled', '');
        plus.setAttribute('aria-disabled', 'true');
      }
    }
  }

  function addUpiMark() {
    var pay = document.querySelector('.sutra-pay');
    if (!pay || pay.querySelector('.sutra-pay__mark--upi')) return;
    var upi = document.createElement('span');
    upi.className = 'sutra-pay__mark sutra-pay__mark--upi';
    upi.textContent = 'UPI';
    upi.setAttribute('aria-label', 'UPI');
    pay.appendChild(upi);
  }

  function go() { fixPolicyControl(); capCartQty(); addUpiMark(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', go);
  } else { go(); }
  window.addEventListener('pageshow', go);
  document.addEventListener('shopify:section:load', go);
  setTimeout(go, 700);
  setTimeout(go, 2000);
})();

/* ==============================================================
   SUTRA v12 — click a thumbnail to swap the hero photograph
   + a SOLD overlay on the hero when the piece is out of stock
   ============================================================== */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  function setupGallery(gal) {
    if (!gal || gal.dataset.sutraSwap) return;
    // Horizon renders TWO sets of containers: a collapsed set (0×0) and
    // visible ones with --force-aspect. Target the visible set.
    var allFrames = gal.querySelectorAll('.product-media-container');
    var frames = [];
    for (var k = 0; k < allFrames.length; k++) {
      if (allFrames[k].classList.contains('product-media-container--force-aspect') ||
          allFrames[k].offsetWidth > 0) {
        frames.push(allFrames[k]);
      }
    }
    if (frames.length < 2) return;
    gal.dataset.sutraSwap = '1';

    var hero = frames[0];
    hero.classList.add('sutra-hero-frame');
    for (var i = 1; i < frames.length; i++) {
      frames[i].classList.add('sutra-thumb');
      frames[i].setAttribute('role', 'button');
      frames[i].setAttribute('tabindex', '0');
      frames[i].setAttribute('aria-label', 'Show photograph ' + (i + 1));
    }

    function activate(f) {
      if (f === hero) return;
      var heroHTML = hero.innerHTML;
      hero.innerHTML = f.innerHTML;
      f.innerHTML = heroHTML;
      for (var i = 0; i < frames.length; i++) frames[i].classList.remove('sutra-active');
      f.classList.add('sutra-active');
      hero.classList.remove('sutra-active');
    }

    gal.addEventListener('click', function (ev) {
      var f = ev.target.closest('.sutra-thumb');
      if (f && gal.contains(f)) { ev.preventDefault(); activate(f); }
    });
    gal.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Enter' && ev.key !== ' ') return;
      var f = ev.target.closest('.sutra-thumb');
      if (f && gal.contains(f)) { ev.preventDefault(); activate(f); }
    });
  }

  function soldOverlay() {
    // Anything the theme itself flags as sold-out
    var soldNode = document.querySelector(
      '.product-information [class*="badge--sold"], ' +
      '.product-information .badge-sold-out, ' +
      '.product-information add-to-cart-component[disabled], ' +
      '.product-information button[name="add"][disabled], ' +
      '.product-information .sold-out');
    var addBtn = document.querySelector('.product-information [name="add"], .product-information add-to-cart-component button');
    var soldByBtn = addBtn && (addBtn.disabled || /sold ?out/i.test(addBtn.textContent || ''));
    if (!soldNode && !soldByBtn) return;

    var heroFrames = document.querySelectorAll('media-gallery .sutra-hero-frame');
    var hero = null;
    for (var h = 0; h < heroFrames.length; h++) {
      if (heroFrames[h].offsetWidth > 0) { hero = heroFrames[h]; break; }
    }
    if (!hero) hero = document.querySelector('media-gallery .product-media-container--force-aspect');
    if (!hero || hero.querySelector('.sutra-sold')) return;
    var chip = document.createElement('span');
    chip.className = 'sutra-sold';
    chip.setAttribute('aria-hidden', 'true');
    chip.textContent = 'SOLD';
    hero.appendChild(chip);

    // Also gray the primary form once, so add-to-cart is visually finished
    var form = document.querySelector('product-form-component, form[action*="/cart/add"]');
    if (form) form.classList.add('sutra-soldout');
  }

  // v18: setupGallery() is no longer called. Since v16 the gallery is
  // Horizon's own carousel with real thumbnails; this older swap marked
  // slides 2..n as .sutra-thumb (72% opacity — black photos read as grey
  // on the cream page) and swapped slide HTML on click, so the thumbnail
  // you pressed stopped matching the photo shown.
  function run() {
    soldOverlay();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  window.addEventListener('pageshow', run);
  document.addEventListener('shopify:section:load', run);
  setTimeout(run, 500);
  setTimeout(run, 1800);
})();

/* ==============================================================
   SUTRA — "Price on Application" for premium pieces (above ₹50,000;
   owner lowered it from ₹1,00,000 on 2026-10-13)
   Hides cart / buy / price, shows WhatsApp enquiry button.
   ============================================================== */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  var THRESHOLD = 50000;   // strictly above this -> price on request
  var WA = '919929615965';

  function getPrice() {
    var el = document.querySelector('product-price .money, .product-information .price .money, product-price');
    if (!el) return 0;
    var txt = (el.textContent || '').replace(/[,\s]/g, '');
    var m = txt.match(/(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : 0;
  }

  function apply() {
    if (document.querySelector('.sutra-poa')) return;
    var price = getPrice();
    if (price <= THRESHOLD) return;

    var info = document.querySelector('.product-information') || document.querySelector('main');
    if (!info) return;
    info.classList.add('sutra-poa-active');

    var title = (document.querySelector('.product-information h1, main h1') || {}).textContent || 'this piece';
    var msg = encodeURIComponent('Hello SUTRA, I\'m interested in ' + title.trim() + '. Could you share the pricing details?');

    var box = document.createElement('div');
    box.className = 'sutra-poa';
    box.innerHTML =
      '<p class="sutra-poa__label">Exclusive Piece</p>' +
      '<p class="sutra-poa__note">This is a bespoke heritage creation &mdash; pricing and availability on enquiry.</p>' +
      '<a class="sutra-poa__btn" href="https://wa.me/' + WA + '?text=' + msg + '" target="_blank" rel="noopener">' +
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>' +
        ' Contact the Shop</a>' +
      '<p class="sutra-poa__sub">A maker replies on WhatsApp &middot; Mon&ndash;Sat, 10am&ndash;7pm IST</p>';

    var priceEl = document.querySelector('.product-information product-price, .product-information .price');
    if (priceEl && priceEl.parentElement) {
      priceEl.parentElement.insertBefore(box, priceEl.nextSibling);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else { apply(); }
  window.addEventListener('pageshow', apply);
  document.addEventListener('shopify:section:load', apply);
  setTimeout(apply, 600);
  setTimeout(apply, 1800);
})();

/* SUTRA v13 hard-coded three reel IDs here and overwrote whatever the
   Instagram section was set to. Removed in v17: the reels are chosen in the
   section settings (theme editor), and that must be the only source. */

/* ==============================================================
   SUTRA v13 — Gallery hero container dimension fix
   Forces the hero frame to match image natural dimensions after
   a thumbnail swap, preventing the 0×0 collapse bug.
   ============================================================== */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  function fixHero() {
    var hero = document.querySelector('media-gallery .sutra-hero-frame, media-gallery .product-media-container:first-child');
    if (!hero) return;
    var img = hero.querySelector('img');
    if (!img) return;

    function applySize() {
      if (img.naturalWidth > 0 && hero.offsetHeight < 10) {
        hero.style.minHeight = Math.min(img.naturalHeight, 600) + 'px';
      }
    }
    if (img.complete) { applySize(); }
    else { img.addEventListener('load', applySize); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixHero);
  } else { fixHero(); }
  setTimeout(fixHero, 1000);
  setTimeout(fixHero, 2500);
})();

/* ==============================================================
   SUTRA v16 — premium-piece cards + product-page accordions
   ============================================================== */
(function () {
  var POA = 50000;   // must match the product-page gate above (strictly above)

  function priceOf(el) {
    var t = (el.textContent || '').replace(/[,\s]/g, '');
    var m = t.match(/(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : 0;
  }

  /* 1. Premium pieces on cards ----------------------------------
     The product page gates anything over ₹50,000 behind an
     enquiry, but the cards still printed the price — and the
     necklace card carried a live quick-add, so the ₹2,82,500 piece
     could go straight into the cart past the gate. Cards now say
     "Price on request" and lose the quick-add; the card link still
     leads to the page with the enquiry button. ------------------ */
  function poaCards(root) {
    var cards = (root || document).querySelectorAll('product-card, .product-card');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.dataset.sutraPoa) return;
      var pp = card.querySelector('product-price');
      if (!pp || !(pp.textContent || '').trim()) return;
      if (priceOf(pp) <= POA) { card.dataset.sutraPoa = 'no'; return; }
      card.dataset.sutraPoa = 'yes';
      card.classList.add('sutra-card--poa');
      pp.innerHTML = '<span class="sutra-poa-card">Price on request</span>';
      var gone = card.querySelectorAll(
        'form[action*="/cart/add"], quick-add-component, .quick-add, [class*="quick-add"]');
      Array.prototype.forEach.call(gone, function (n) { n.remove(); });
    });
  }

  /* 2. Product-page accordions ---------------------------------
     The older pieces stacked a "why" box, a seven-row spec table,
     two paragraphs and four craft notes that restate the box — a
     wall of text beside the photograph. Fold it into three quiet
     sections, the short "why" open. Descriptions that are already
     short (pendants, brooches) are left exactly as they are. ---- */
  function accordions() {
    if (!/\/products\//.test(location.pathname)) return;
    var why = document.querySelector('.sutra-why');
    var rte = why ? why.closest('rte-formatter, .rte') : null;
    if (!rte || rte.dataset.sutraAcc) return;
    if ((rte.textContent || '').replace(/\s+/g, ' ').trim().length < 500) return;
    rte.dataset.sutraAcc = '1';

    var buckets = { why: [], story: [], specs: [] };
    var drop = [];
    var inSpecs = false;
    Array.prototype.slice.call(rte.children).forEach(function (el) {
      if (el.classList.contains('sutra-why')) { buckets.why.push(el); return; }
      if (/^H[2-5]$/.test(el.tagName) && /specification/i.test(el.textContent)) {
        drop.push(el); inSpecs = true; return;
      }
      if (inSpecs && (el.classList.contains('rte-table-wrapper') || el.tagName === 'TABLE')) {
        buckets.specs.push(el); inSpecs = false; return;
      }
      buckets.story.push(el);
    });
    drop.forEach(function (n) { n.remove(); });

    function section(title, nodes, open) {
      if (!nodes.length) return null;
      var d = document.createElement('details');
      d.className = 'sutra-acc';
      if (open) d.open = true;
      var s = document.createElement('summary');
      s.className = 'sutra-acc__summary';
      s.textContent = title;
      var b = document.createElement('div');
      b.className = 'sutra-acc__body';
      nodes.forEach(function (n) { b.appendChild(n); });
      d.appendChild(s); d.appendChild(b);
      return d;
    }
    [section('Why this piece is exceptional', buckets.why, true),
     section('About this piece', buckets.story, false),
     section('Specifications', buckets.specs, false)]
      .forEach(function (d) { if (d) rte.appendChild(d); });
  }

  function run() { poaCards(); accordions(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('pageshow', run);
  document.addEventListener('shopify:section:load', run);
  setTimeout(run, 700);
  setTimeout(run, 2000);

  /* Cards also arrive later — recommendations load async, and filters
     and sorting re-render the grid — so watch for new ones. */
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; poaCards(); }, 120);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* ==============================================================
   SUTRA v17 — trust pass: "ask about this piece" on WhatsApp under
   the buy buttons, and a reassurance line under every checkout
   button. A buyer about to spend Rs 20,000 with a shop they have
   never heard of wants to know a person will answer — one tap to
   the atelier's own number says that better than any badge.
   ============================================================== */
(function () {
  var WA = '919929615965';
  var WA_ICON = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" ' +
    'stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><path d="M3.6 20.4 4.9 16A8.2 8.2 0 1 1 8.1 19.2z"/>' +
    '<path d="M9 8.6c-.3.7-.1 1.6.5 2.5a8 8 0 0 0 3.3 3c.9.4 1.8.5 2.4 0"/></svg>';
  var LOCK = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" ' +
    'stroke-width="1.8" aria-hidden="true"><rect x="4.5" y="10.5" width="15" height="10"/>' +
    '<path d="M8 10.5V7.3a4 4 0 0 1 8 0v3.2"/></svg>';

  function askButton() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('.sutra-ask')) return;
    var trust = document.querySelector('.sutra-trust');
    if (!trust) return;
    var title = ((document.querySelector('.product-information h1, main h1') || {}).textContent || '').trim();
    var url = location.origin + location.pathname;
    var msg = 'Hi SUTRA, I have a question about the ' + title + ' — ' + url;
    var a = document.createElement('a');
    a.className = 'sutra-ask';
    a.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(msg);
    a.target = '_blank';
    a.rel = 'noopener';
    a.innerHTML = WA_ICON + '<span>Ask about this piece on WhatsApp</span>';
    trust.parentNode.insertBefore(a, trust);
  }

  function cartTrust() {
    var btns = document.querySelectorAll(
      'button[name="checkout"], .cart__checkout-button, a[href="/checkout"]');
    for (var i = 0; i < btns.length; i++) {
      var host = btns[i].closest('.cart__ctas, .cart-actions, form, div') || btns[i].parentElement;
      if (!host || host.querySelector('.sutra-cart-trust')) continue;
      var p = document.createElement('p');
      p.className = 'sutra-cart-trust';
      p.innerHTML = LOCK + 'Shipping &#8377;379 across India &middot; secure checkout &middot; 14-day returns';
      host.appendChild(p);
    }
  }

  function run() { askButton(); cartTrust(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('pageshow', run);
  document.addEventListener('shopify:section:load', run);
  setTimeout(run, 800);
  setTimeout(run, 2200);
  // the cart drawer renders its footer when it opens
  if (window.MutationObserver) {
    var t = null;
    new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; cartTrust(); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* ==============================================================
   SUTRA v17b — what a buyer checks before paying, shown before
   they pay: the shipping cost (a flat Rs 379 within India — the
   only rate checkout offers), when it leaves the atelier, how it
   is packed, and how returns work. Every line is the shipping and
   returns policy's own wording, so the page and checkout agree.
   Plus the payment marks checkout actually accepts, copied from
   the footer (Liquid renders them from shop.enabled_payment_types).
   ============================================================== */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  function build() {
    var trust = document.querySelector('.sutra-trust');
    if (!trust || document.querySelector('.sutra-deliv')) return;

    var pay = document.querySelector('.sutra-pay');
    if (pay) {
      var marks = pay.cloneNode(true);
      marks.className = 'sutra-pay sutra-pay--pdp';
      marks.removeAttribute('aria-label');
      marks.setAttribute('aria-label', 'Payment methods accepted at checkout');
      trust.parentNode.insertBefore(marks, trust.nextSibling);
      trust = marks;
    }

    var cat = window.sutraCategory ? window.sutraCategory() : '';
    var made = /^(rings|bracelets)$/.test(cat);
    var rows = [
      ['Shipping', 'Flat &#8377;379 anywhere in India, tracked and insured for the full value. Shown at checkout before you pay.'],
      ['Dispatch', made
        ? 'Made to your size at our Jaipur bench &mdash; leaves in 10&ndash;15 business days, then 2&ndash;5 days to reach you.'
        : 'Leaves the Jaipur atelier in 2&ndash;5 business days, then 2&ndash;5 days to reach you. Tracking link by email.'],
      ['Packaging', 'Velvet pouch, boxed, sealed in a tamper-evident outer. Gift orders can go without an invoice inside &mdash; just ask.'],
      ['Returns', cat === 'earrings'
        ? '14 days from delivery while the pouch seal is unbroken (a hygiene rule). Refund to your original payment.'
        : '14 days from delivery, unworn and in its box. Refund to your original payment within 5 business days.']
    ];
    var html = '<summary class="sutra-acc__summary">Delivery, packaging &amp; returns</summary><div class="sutra-acc__body"><dl class="sutra-deliv__list">';
    for (var i = 0; i < rows.length; i++) {
      html += '<div class="sutra-deliv__row"><dt>' + rows[i][0] + '</dt><dd>' + rows[i][1] + '</dd></div>';
    }
    html += '</dl><p class="sutra-deliv__links"><a href="/pages/shipping-policy-sutra">Shipping policy</a>' +
            '<a href="/pages/refund-returns-policy">Returns policy</a></p></div>';
    var d = document.createElement('details');
    d.className = 'sutra-acc sutra-deliv';
    d.innerHTML = html;
    trust.parentNode.insertBefore(d, trust.nextSibling);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
  window.addEventListener('pageshow', build);
  document.addEventListener('shopify:section:load', build);
  setTimeout(build, 900);
  setTimeout(build, 2400);
})();

